export default __webpack_public_path__ + "static/media/u-shaped.68c8402d.svg";